<template>
  <div>
    <div class="">
      <header class="navbar navbar-header navbar-header-fixed">
        <a href="#" id="mainMenuOpen" class="burger-menu"
          ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-menu"
          >
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line></svg
        ></a>
        <div class="navbar-brand">
          <a href="../../index.html" class="df-logo"
            ><img
              :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
              style="max-width: 40px"
          /></a>
        </div>
        <!-- navbar-brand -->
        <div id="navbarMenu" class="navbar-menu-wrapper">
          <div class="navbar-menu-header">
            <a href="../../index.html" class="df-logo"
              ><img :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
            /></a>
            <a id="mainMenuClose" href=""
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line></svg
            ></a>
          </div>
          <!-- navbar-menu-header -->
          <ul class="nav navbar-menu">
            <li class="nav-item">
              <a href="#" class="nav-link">
                <feather type="menu"></feather>
                Тээврийн автомашины дарааллын систем
              </a>
            </li>
          </ul>
        </div>
        <!-- navbar-menu-wrapper -->
        <div class="navbar-right"></div>
        <!-- navbar-right -->
      </header>
    </div>

    <div class="content content-fixed content-auth d-none">
      <div v-if="$route.params.cid == 0" class="container">
        <div
          class="media align-items-stretch justify-content-center ht-100p pos-relative"
        >
          <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
            <div class="wd-100p">
              <h3 class="tx-color-01 mg-b-5">Нэвтрэх</h3>
              <p class="tx-color-03 tx-16 mg-b-40">
                Та нэвтэрч орсноор үргэлжлүүлэх боломжтой.
              </p>

              <div class="form-group">
                <label>Улсын дугаар</label>
                <input
                  type="text"
                  v-on:keyup="checkEnter"
                  v-model="loginModel.username"
                  class="form-control"
                  placeholder="1234 ДГО"
                />
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Нууц код</label>
                  <a href="" class="tx-13">Мартсан?</a>
                </div>
                <input
                  type="password"
                  v-on:keyup="checkEnter"
                  v-model="loginModel.password"
                  class="form-control"
                  placeholder="Нууц кодоо оруулна уу"
                />
              </div>
              <button @click="login" class="btn btn-brand-02 btn-block">
                Нэвтрэх
              </button>
              <div class="divider-text">эсвэл</div>
              <router-link
                :to="{
                  name: 'landingTads',
                  params: { id: $store.state.app.homePageId, cid: 1 }
                }"
                class="btn btn-success btn-block"
                role="button"
                >Бүртгүүлэх</router-link
              >
            </div>
          </div>
          <!-- sign-wrapper -->
        </div>
        <!-- media -->
      </div>
      <div v-else-if="$route.params.cid == 1" class="container">
        <div
          class="media align-items-stretch justify-content-center ht-100p pos-relative"
        >
          <div class="sign-wrapper mg-lg-l-50 mg-xl-l-60">
            <div class="wd-100p">
              <h3 class="tx-color-01 mg-b-5">Бүртгүүлэх</h3>

              <div class="form-group">
                <label>Улсын дугаар</label>
                <input
                  v-model="registerModel.userLogin"
                  type="text"
                  class="form-control"
                  placeholder="1234 ДГО"
                />
              </div>
              <div class="form-group">
                <label>Нууц код</label>
                <input
                  v-model="registerModel.userPass"
                  type="text"
                  class="form-control"
                  placeholder=""
                />
                <div class="tx-color-03">
                  Хэрэглэгч өөрөө оруулна. Дараа нэвтэрч орохдоо ашиглана
                </div>
              </div>
              <div class="divider-text">жолоочийн мэдээлэл</div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Эцэг/Эх-н нэр</label>
                </div>
                <input
                  v-model="registerModel.userOvog"
                  type="text"
                  class="form-control"
                  placeholder="оруулна уу"
                />
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Нэр</label>
                </div>
                <input
                  v-model="registerModel.userNer"
                  type="text"
                  class="form-control"
                  placeholder="оруулна уу"
                />
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Регистр №</label>
                </div>
                <input
                  v-model="registerModel.userRegister"
                  type="text"
                  class="form-control"
                  placeholder="оруулна уу"
                />
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mg-b-5">
                  <label class="mg-b-0-f">Утас</label>
                </div>
                <input
                  v-model="registerModel.userUtas"
                  type="text"
                  class="form-control"
                  placeholder="оруулна уу"
                />
              </div>
              <button @click="register()" class="btn btn-success btn-block">
                Бүртгүүлэх
              </button>

              <router-link
                :to="{
                  name: 'landingTads',
                  params: { id: $store.state.app.homePageId, cid: 0 }
                }"
                class="btn btn-outline-primary btn-block"
                role="button"
                >Буцах</router-link
              >
            </div>
          </div>
          <!-- sign-wrapper -->
        </div>
        <!-- media -->
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
const { resBaseUrl } = config;

import { mapActions } from "vuex";

import { request } from "@/api/all";

export default {
  data() {
    return {
      loginModel: {
        loading: null,
        username: "",
        password: ""
      },
      registerModel: {
        userLogin: "",
        userPass: "",
        userPass: "",
        userOvog: "",
        userNer: "",
        userUtas: "",
        userRegister: ""
      },
      myResBaseUrl: resBaseUrl
    };
  },
  mounted() {
    require("@/assets/scss/pages/auth.scss");
    //this.toggleBodyClass("addClass", "app-lms");
    //require("@/assets/css/dynamic.lms.css");
    //this.doLogin();
  },
  beforeDestroy() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    ...mapActions([
      "handleLogin",
      "handleLoginGolomt",
      "handleUserInfo",
      "handleLoading",
      "handleLogOut",
      "handleDynamicMenuLoaded",
      "handleSnackbar",
      "handleGroupSettings",
      "handleUsersettings",
      "handleGroupDefaultProjects",
      "handleRoutes",
      "handleSignalR",
      "handlePersonalSettings",
      "handleActiveGroup"
    ]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    login() {
      if (this.loginModel.username.length == 0) {
        this.$bvToast.toast(`Улсын дугаар хоосон байна.`, {
          title: "Мэдэгдэл",
          autoHideDelay: 15000,
          appendToast: true
        });
      } else if (this.loginModel.password.length == 0) {
        this.$bvToast.toast(`Нууц үг хоосон байна.`, {
          title: "Мэдэгдэл",
          autoHideDelay: 15000,
          appendToast: true
        });
      } else {
        this.doLogin();
      }
    },
    checkEnter(e) {
      if (e.keyCode === 13) {
        this.login();
      }
    },
    doLogin() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      this.handleLogin({
        user: "tads.admin",
        password: "t@ds123",
        key: this.$store.state.app.activeGroup.key
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.loginAfter(res);
        }
      });
    },
    loginAfter(res) {
      this.handleUserInfo({ store: this.$store }).then(irs => {
        if (irs != false) {
          this.handleGroupSettings({ store: this.$store }).then(stt => {
            if (stt != false) {
              this.handleUsersettings({ store: this.$store }).then(ustt => {
                //console.log('ustt', ustt, (ustt != false));
                if (ustt != false) {
                  this.handleGroupDefaultProjects({
                    store: this.$store
                  }).then(res => {
                    if (res != false) {
                      this.handleRoutes({ router: this.$router })
                        .then(() => {
                          this.handleSignalR()
                            .then(() => {
                              this.handleLoading({ isLoading: false });
                              this.$router.push("/apptads/home");
                            })
                            .catch(() => {
                              this.handleLoading({ isLoading: false });
                              this.$bvToast.toast(
                                `Мессеж хүлээн авах сокетын холболт амжилтгүй боллоо.`,
                                {
                                  title: "Мэдэгдэл",
                                  autoHideDelay: 15000,
                                  appendToast: true
                                }
                              );
                              //this.manageRedirect();
                            });
                        })
                        .catch(() => {
                          this.$bvToast.toast(
                            `Алдаатай хүсэлт ирлээ. Системийг ахин ачааллана уу.`,
                            {
                              title: "Мэдэгдэл",
                              autoHideDelay: 15000,
                              appendToast: true
                            }
                          );
                          this.handleLoading({ isLoading: false });
                        });
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
    register() {
      let errs = [];

      if (this.registerModel.userLogin.length == 0) {
        errs.push("Улсын дугаар оруулна уу");
      } else if (this.registerModel.userPass.length == 0) {
        errs.push("Нууц код оруулна уу");
      } else if (this.registerModel.userOvog.length == 0) {
        errs.push("Эцэг/Эх-н нэр оруулна уу");
      } else if (this.registerModel.userNer.length == 0) {
        errs.push("Нэр оруулна уу");
      } else if (this.registerModel.userRegister.length == 0) {
        errs.push("Регистр № оруулна уу");
      } else if (this.registerModel.userUtas.length == 0) {
        errs.push("Утас № оруулна уу");
      }

      if (errs.length > 0) {
        this.$bvToast.toast(errs[0], {
          title: "Мэдэгдэл",
          autoHideDelay: 15000,
          appendToast: true
        });
      } else {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "User/RegisterTads" },
          data: this.registerModel,
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");

          this.toggleBodyClass("addClass", "dynamic-locker");
          this.handleLogin({
            user: this.registerModel.userLogin,
            password: this.registerModel.userPass,
            key: this.$store.state.app.activeGroup.key
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              this.$bvToast.toast("Бүртгүүллээ", {
                title: "Амжилттай",
                autoHideDelay: 15000,
                appendToast: true
              });
              this.loginAfter(res);
            }
          });
          // ввthis.handleLoading({ isLoading: false });
          // if (res != false) {
          //   Notification.success({
          //     message:
          //       "Таны бүртгэл амжилттай үүслээ. Таны и-мэйл хаягаар очсон баталгаажуулах кодыг оруулна уу.",
          //     title: "Амжилттай",
          //     duration: 30000,
          //     type: "success",
          //     position: "top-right",
          //     offset: 50
          //   });
          //   localSave("activationGroupId", res.mailRenew.groupId);
          //   localSave("activationUserId", res.mailRenew.userId);
          //   this.$router.push({ name: "activation" });
          // }
        });
      }
    }
  }
};
</script>
